import { ChangeEvent, FocusEvent } from "react"

import { Box } from "@material-ui/core"
import { ContactPhone } from "models/common"
import { ErrorsMap } from "api/http/utils"
import { Select } from "components/inputs/Select"
import { TextInput } from "components/inputs/TextInput"
import { agencyClientStyles } from "./styles"
import { get } from "lodash/fp"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"

type Props = {
  idx: number
  source: ContactPhone
  onChange: (
    evt: ChangeEvent<
      | HTMLInputElement
      | {
          name?: string | undefined
          value: unknown
        }
    >,
  ) => void
  onBlur: (evt: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  errors?: ErrorsMap
}

const PHONE_TYPES = ["Business", "Mobile", "Office", "Home"]

export function Phone(props: Props) {
  const { t } = useI18n()
  const { idx, source, onChange, onBlur, errors } = props
  const { hasAuthority } = useAuthenticated()

  return (
    <Box
      display="grid"
      gridAutoFlow="column"
      alignItems="center"
      gridTemplateColumns="minmax(min-content, 145px) auto auto"
    >
      <Select
        margin="none"
        className={agencyClientStyles.number}
        classes={{
          icon: agencyClientStyles.selectIcon,
        }}
        id="contact.phone.type"
        name={`contact.phones.${idx}.type`}
        value={source?.type || ""}
        label={t("contact.phone.number")}
        placeholder={t("contact.phone.type")}
        onChange={onChange}
        onBlur={onBlur}
        options={PHONE_TYPES.map((tp) => ({
          label: t(`phone.type.${tp}`.toLowerCase()),
          value: tp,
        }))}
        disabled={!hasAuthority(["AUTH_EDIT_AGENCY_CLIENT_PROFILE"])}
      />
      <TextInput
        id="contact.phone.number"
        name={`contact.phones.${idx}.number`}
        value={source?.number || ""}
        label={t("contact.phone.number")}
        margin="none"
        size="medium"
        className={agencyClientStyles.phoneInput}
        onChange={onChange}
        onBlur={onBlur}
        error={!!get(`contact.phones.${idx}.number`, errors)}
        errorMessage={get(`contact.phones.${idx}.number`, errors)}
        disabled={!hasAuthority(["AUTH_EDIT_AGENCY_CLIENT_PROFILE"])}
      />
      <TextInput
        id="contact.phone.extension"
        name={`contact.phones.${idx}.extension`}
        value={source?.extension || ""}
        label={t("contact.phone.extension")}
        margin="none"
        size="medium"
        className={agencyClientStyles.extension}
        onChange={onChange}
        onBlur={onBlur}
        error={!!get(`contact.phones.${idx}.extension`, errors)}
        errorMessage={get(`contact.phones.${idx}.extension`, errors)}
        disabled={!hasAuthority(["AUTH_EDIT_AGENCY_CLIENT_PROFILE"])}
      />
    </Box>
  )
}
